var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{staticClass:"img-fluid logo_img",attrs:{"src":_vm.sectionImage,"alt":"#"}}),_vm._v(" "),_c('div',{class:'iq-font-'+_vm.sectionColor+'iq-mt-15'},[_vm._v("\n    "+_vm._s(_vm.sectionText)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }